<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_title">
        <span class="Modal_title_date">日付で選ぶ</span>
      </div>
      <div class="Modal_inner modal__container">
        <div v-for="(scheduleClassOfDate,month) of listClasses" :id="`month-${month}`" :key="month" class="Search_date_box">
          <p class="Search_date_box_month_area">
            <span>{{ showMonth(month) }}</span>月
          </p>
          <ul class="Search_date_list">
            <li v-for="scheduleClass of scheduleClassOfDate" :key="scheduleClass.id" class="Search_date_list_box">
              <a
                class="Search_date_list_link _cross"
                @click="searchDay(scheduleClass.learning_day)"
              >
                <span>{{ showDay(scheduleClass.learning_day) }}</span>
                {{ showDate(scheduleClass.learning_day) }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
import melontvService from '@/services/melontvService'
import moment from 'moment'
export default {
  name: 'MelonTVScheduleModal4',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listClasses: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    modalClose() {
      this.$emit('close')
    },
    async init() {
      await this.getListClasses()
    },
    handleListClasses(list) {
      const listDate = {}
      list.forEach(function(item, key) {
        if (item.date !== null) {
          const month = moment(item.date).format('YYYY-MM')
          if (typeof listDate[month] !== 'undefined') {
            listDate[month].push(item)
          } else {
            listDate[month] = [item]
          }
        }
      })
      this.listClasses = listDate
    },
    async getListClasses() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await melontvService.index()
      this.handleListClasses(response.data)
      this.$store.dispatch('loading/updateLoading', false)
    },
    showDay(date) {
      return moment(date).format('DD')
    },
    showDate(date) {
      return moment(date).locale('ja').format('ddd')
    },
    showMonth(date) {
      return moment(date).format('M')
    },
    searchDay(day) {
      this.$emit('searchMelonTv', { searchDay: day })
      this.$emit('close')
    }
  }
}
</script>
